import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Modal from "@mui/material/Modal";
import { Fragment, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, TextField, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Radio from "@mui/material/Radio";
import eyeSlash from "../Images/eye-slash.svg";
import eye from "../Images/eye.svg";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Loader from "../Loader";
// import nodata from "../Images/nothingfound.svg";
import nodata from "../Images/ImageToStl.com_nothingfound.avif";
import hostinger from "../Images/hostinger 2.svg";
import amazon1 from "../Images/amazon 1.svg";
import ses1 from "../Images/SES 1.svg";
import s163 from "../Images/163.svg";
import alliyon from "../Images/aliyun 1.svg";
import locaWeb from "../Images/locaweb 1.svg";
import ionos1 from "../Images/lonos 1.svg";
import sendGrid from "../Images/sendgrid 1.svg";
import send2 from "../Images/send-2.svg";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Fade } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import WorkspaceModalUi from "../Components/WorkspaceModalUi";
import { Drawer } from "rsuite";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GenerateAppPasswordModal from "../Components/GenerateAppPasswordModal";
import SetUpAppPasswordModalUi from "../Components/SetupAppPasswordModal";
import MicrosoftAccountModal from "../Components/MicrosoftAccountModal";

const chartOptions = {
  chart: {
    type: "areaspline",
    height: 250,
  },
  title: {
    text: " ",
    align: "left",
  },
  legend: {
    enabled: false,
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    lineWidth: 0,
    tickWidth: 0,
    title: {
      text: "Revenue",
      color: "#000000",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "Source Sans 3",
      fontStyle: "normal",
    },
  },
  yAxis: {
    title: {
      text: "Deliverability",
      color: "#000000",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "Source Sans 3",
      fontStyle: "normal",
    },
    labels: {
      enabled: false, // Hide the y-axis labels
    },
    gridLineWidth: 1, // Thickness of the grid lines
    gridLineColor: "red", // Color of the grid lines
    gridLineDashStyle: "Dash",
  },
  tooltip: {
    shared: true,
    headerFormat: "<b>Deliverability of {point.x}</b><br>",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      pointStart: 20,
    },
    areaspline: {
      fillOpacity: 0.7,
      lineColor: "red",
      color: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, "rgba(83, 216, 106, 1)"], // Start color (fully opaque)
          [1, "rgba(83, 216, 106, 0)"], // End color (fully transparent)
        ],
      },
      marker: false,
      lineWidth: 3,
    },
  },
  series: [
    {
      name: "Revenue",
      data: [20, 25, 30, 35, 40, 50, 55, 60, 65, 70, 80, 90],
    },
  ],
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};

const EmailAccountsCopy = (props) => {
  const history = useHistory();
  const locData = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [open3, setOpen3] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [advance, setAdvance] = useState(false);
  const [statusLoader, setStatusLoader] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState({
    status: true,
  });
  const [checkIndex, setCheckIndex] = useState("");
  const [name, setName] = useState("");
  const [replyName, setReplyName] = useState("");
  const [messagePerDay, setMessagePerDay] = useState("");
  const [recordName, setRecordName] = useState("");
  const [detailsDomain, setDetailsDomain] = useState([]);
  const [cert, setCert] = useState("");
  const [diffReplyMail, setDiffReplyMail] = useState("");
  const [diffReply, setDiffReply] = useState(false);
  const [rcvConfirm, setRcvConfirm] = useState(false);
  const [senderMails, setSenderMails] = useState([]);
  const [senderMailsCopy, setSenderMailsCopy] = useState([]);
  const [email, setEmail] = useState("");
  const [hostName, setHostName] = useState("");
  const [hostNameDup, setHostNameDup] = useState("");
  const [rcvHostName, setRcvHostName] = useState("");
  const [rcvHostNameDup, setRcvHostNameDup] = useState("");
  const [portNumber, setPortNumber] = useState("");
  const [portNumberDup, setPortNumberDup] = useState("");
  const [rcvPortNumber, setRcvPortNumber] = useState("");
  const [mailType, setMailType] = useState("");
  const [rcvPortNumberDup, setRcvPortNumberDup] = useState("");
  const [selected, setSelected] = useState("Domain health");
  const [type, setType] = useState("");
  const [rcvHostArr, setRcvHostArr] = useState([]);
  const [addStatus, setAddStatus] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const handleClose = () => setOpen3(false);
  const [passwordStatus, setPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  const [replyPasswordStatus, setReplyPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  useEffect(() => {
    setType("");
    setAddStatus(false);
  }, [locData.pathname]);
  const [hostNameArr, setHostNameArr] = useState([]);
  const hostNameGoogle = ["smtp.gmail.com", "smtp-relay.gmail.com"];
  const hostNameZoho = [
    "smtp.zoho.eu",
    "smtp.zoho.com",
    "smtppro.zoho.com",
    "smtp.zoho.com.cn",
    "smtppro.zoho.in",
    "smtppro.zoho.eu",
    "smtp.zoho.com.au",
    "smtp.zoho.in",
    "smtp.zoho.jp",
  ];
  const hostNameGoDaddy = [
    "smtpout.secureserver.net",
    "smtpout.asia.secureserver.net",
    "smtpout.europe.secureserver.net",
    "sxb1plzcpnl440004.prod.sxb1.secureserver.net",
  ];
  const hostNameSendGrid = ["smtp.sendgrid.net", "smtp.sendgrid.com"];
  const hostNamePrivate = ["mail.privateemail.com", "smtp.privateemail.com"];
  const hostNameQQ = [
    "smtp.qq.com",
    "smtp.exmail.qq.com",
    "hwsmtp.exmail.qq.com",
  ];
  const hostNameHostinger = [
    "smtp.hostinger.com",
    "smtp.hostinger.lt",
    "smtp.hostinger.ph",
    "smtp.hostinger.in",
    "smtp.hostinger.com.br",
  ];
  const hostNameTitan = ["smtp.titan.email", "titanium.cloudhosting.co.uk"];
  const hostNameAmazonWork = [
    "smtp.mail.us-west-2.awsapps.com",
    "smtp.mail.us-east-1.awsapps.com",
    "smtp.mail.eu-west-1.awsapps.com",
  ];
  const hostNameMail163 = [
    "smtp.qiye.163.com",
    "smtphz.qiye.163.com",
    "smtp.163.com",
    "smtp.ym.163.com",
    "smtphm.qiye.163.com",
    "hwsmtp.qiye.163.com",
    "applesmtp.163.com",
    "smtp.vip.163.com",
    "hwhzsmtp.qiye.163.com",
  ];
  const hostNameLocaWeb = ["email-ssl.com.br"];
  const hostNameIonos = [
    "smtp.ionos.com",
    "smtp.ionos.es",
    "smtp.ionos.fr",
    "smtp.exchange2019.ionos.fr",
    "smtp.ionos.it",
    "smtp.ionos.co.uk",
    "smtp.exchange2019.ionos.co.uk",
    "smtp.ionos.mx",
    "smtp.ionos.de",
  ];
  const hostNameAliyun = [
    "smtp.aliyun.com",
    "smtp.qiye.aliyun.com",
    "smtpdm.aliyun.com",
    "smtpdm-ap-southeast-1.aliyun.com",
  ];
  const hostNameAmazonSes = [
    "email-smtp.us-east-2.amazonaws.com",
    "email-smtp.us-east-1.amazonaws.com",
    "email-smtp-fips.us-east-1.amazonaws.com",
    "email-smtp.us-west-1.amazonaws.com",
    "email-smtp.us-west-2.amazonaws.com",
    "email-smtp-fips.us-west-2.amazonaws.com",
    "email-smtp.ap-south-1.amazonaws.com",
    "email-smtp.ap-northeast-3.amazonaws.com",
    "email-smtp.ap-northeast-2.amazonaws.com",
    "email-smtp.ap-southeast-1.amazonaws.com",
    "email-smtp.ap-southeast-2.amazonaws.com",
    "email-smtp.ap-northeast-1.amazonaws.com",
    "email-smtp.ca-central-1.amazonaws.com",
    "email-smtp.eu-central-1.amazonaws.com",
    "email-smtp.eu-west-1.amazonaws.com",
    "email-smtp.eu-west-2.amazonaws.com",
    "email-smtp.eu-west-3.amazonaws.com",
    "email-smtp.eu-north-1.amazonaws.com",
    "email-smtp.sa-east-1.amazonaws.com",
  ];
  const hostNameMailGun = ["smtp.mailgun.org", "smtp.eu.mailgun.org"];
  const hostNameMicrosoft = ["smtp.office365.com", "smtp.live.com"];
  const rcvHostArrGmail = ["imap.gmail.com"];
  const rcvHostArrZoho = [
    "imappro.zoho.com",
    "imap.zoho.com",
    "imappro.zoho.eu",
    "imap.zoho.eu",
    "imap.zoho.com.cn",
    "imap.zoho.in",
    "imappro.zoho.in",
    "imap.zoho.com.au",
  ];
  const rcvHostArrGoDaddy = [
    "imap.asia.secureserver.net",
    "imap.secureserver.net",
  ];
  const rcvHostArrPrivate = ["mail.privateemail.com", "imap.privateemail.com"];
  const rcvHostArrQq = [
    "imap.qq.com",
    "imap.exmail.qq.com",
    "hwimap.exmail.qq.com",
  ];
  const rcvHostArrHostinger = [
    "imap.hostinger.com",
    "imap.hostinger.lt",
    "imap.hostinger.ph",
    "imap.hostinger.in",
    "imap.hostinger.com.br",
  ];
  const rcvHostArrTitan = ["imap.titan.email", "titanium.cloudhosting.co.uk"];
  const rcvHostArrAmazonWork = [
    "imap.mail.us-east-1.awsapps.com",
    "imap.mail.eu-west-1.awsapps.com",
    "imap.mail.us-west-2.awsapps.com",
  ];
  const rcvHostArrMail163 = [
    "imap.qiye.163.com",
    "imap.vip.163.com",
    "hwhzimap.qiye.163.com",
    "imap.ym.163.com",
    "imaphz.qiye.163.com",
    "imap.163.com",
    "imaphm.qiye.163.com",
    "hwimap.qiye.163.com",
    "appleimap.163.com",
  ];
  const rcvHostArrLocaWeb = ["email-ssl.com.br"];
  const rcvHostArrIonos = [
    "imap.ionos.es",
    "imap.ionos.com",
    "imap.ionos.fr",
    "mail.ionos.com",
    "imap.ionos.co.uk",
    "exchange2019.ionos.fr",
    "imap.ionos.it",
    "exchange2019.ionos.co.uk",
    "imap.ionos.mx",
    "imap.ionos.de",
  ];
  const rcvHostArrMicrosoft = [
    "imap-mail.outlook.com",
    "outlook.office365.com",
  ];
  const portNumberArr = ["465", "587", "25"];
  const rcvPortNumberArr = ["993", "143"];
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showReplyPassword, setShowReplyPassword] = useState(false);
  const [replyPassword, setReplyPassword] = useState("");
  const [filterDefaultValue, setFilterDefaultValue] = useState("Active");
  const [openModal, setOpenModal] = useState(false);
  const [openUnsubscribeModal, setOpenUnsubscribeModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sendLoader, setSendLoader] = useState(false);

  const certArr = ["SSL", "TLS", "None"];

  const arrayOfObjects = [
    {
      id: 1,
      title: "Domain health",
    },
    {
      id: 2,
      title: "Email warm-up",
    },
    // {
    //   id: 3,
    //   title: "BCC to CRM",
    // },
  ];

  function togglePassword() {
    setShowPassword(!showPassword);
  }
  function addSender() {
    setSendLoader(true);
    let senderData = {
      code: "",
      fromEmail: email,
      fromName: name,
      password: password.replace(/ /g, ""),
      port: portNumber,
      host: hostName,
      service: true, //gmail and microsof true for others false
      serviceName: "gmail", //for microsoft hotmail for others empty
      imapUsername: replyName ? replyName : name,
      imapPassword: replyPassword
        ? replyPassword.replace(/ /g, "")
        : password.replace(/ /g, ""),
      imapHost: rcvHostName,
      imapPort: rcvPortNumber,
      imapEmail: diffReply ? diffReplyMail : email,
      limit: messagePerDay,
      token: "",
      refreshToken: "",
      tokenExpiryDate: new Date(),
      type: mailType,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/check-user-added-email/${
          userDetails && userDetails.details._id
        }`,
        senderData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        setConnectionStatus(res.data);
        if (res.data.status) {
          axios
            .post(
              `${
                BaseUrl.baseurl
              }/email-marketing/user-from-email/add-user-from-email-details/${
                userDetails && userDetails.details._id
              }`,
              senderData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                props.statusObj({
                  status: response.data.status,
                  message: response.data.message,
                });
                // toast.success(response.data.message, {
                //   autoClose: true,
                //   position: "top-right",
                //   duration: 3000,
                // });
                getAllSendEmails();
                setAddStatus(false);
              } else {
                setAdvance(true);
                props.statusObj({
                  status: response.data.status,
                  message: response.data.message,
                });
                // toast.error(response.data.message, {
                //   autoClose: true,
                //   position: "top-right",
                //   duration: 3000,
                // });
                if (res.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        } else {
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setShowToast(true);
        setSendLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllSendEmails();
  }, []);

  function getAllSendEmails() {
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/get-all-user-from-emails-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setSenderMails(response.data.details.AddedEmails);
          setSenderMailsCopy(response.data.details.AddedEmails);
        } else {
          setSenderMails([]);
          setSenderMailsCopy([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setIsLoading(false);
      })
      .catch((err) => console.log("Error"));
  }
  function deleteAccountUser() {
    setOpen4(false);
    axios
      .delete(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/delete-user-from-email/${
          userDetails && userDetails.details._id
        }/${selectedEmail._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setShowToast(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          getAllSendEmails();
        } else {
          setShowToast(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const trackingDomainData = [
    {
      id: 1,
      title: "Step 1",
      subject: (
        <span>
          Watch our{" "}
          <b style={{ color: "#1C485F", fontWeight: 400 }}>video tutorial</b> or
          read the <b style={{ color: "#1C485F", fontWeight: 400 }}>guide</b>{" "}
          first. There you'll find detailed steps to setting up a tracking
          domain. If you already have one, go to step 2.
        </span>
      ),
    },
    {
      id: 2,
      title: "Step 2",
      subject:
        "In your domain settings panel, add a new CNAME record snov-stream.com for your tracking domain/subdomain.",
    },
    {
      id: 3,
      title: "Step 3",
      subject:
        "Paste your new tracking domain/subdomain in the field below and verify that it's ready.",
    },
  ];

  const customTrackingDomain = () => {
    return (
      <div style={{ borderRadius: "12px", padding: "10px" }}>
        <ul style={{ padding: "0px" }}>
          {trackingDomainData.map((data) => (
            <li key={data.id}>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <span
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.title}:
                </span>
                <p
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "13px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.subject}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Tracking domain
          </p>
          <input
            type="text"
            style={{
              padding: "8px",
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #1C485F",
              flexGrow: 1,
              outline: "none",
            }}
            placeholder="Enter your track url"
          />
          <button
            style={{
              backgroundColor: "#1C485F",
              color: "#fff",
              padding: "8px 20px",
              borderRadius: "4px",
              outline: "none",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Verify
          </button>
        </div>
      </div>
    );
  };

  const signatureUi = () => {
    return (
      <div style={{ padding: "12px" }}>
        <p
          style={{
            color: "#868686",
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          Add an email signature that will be shown at the end of each email.
        </p>
        <div
          style={{
            backgroundColor: "#FAFAFA",
            padding: "4px 0px",
            borderRadius: "4px",
            display: "flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => setOpenModal(true)}
            style={{
              border: "1px solid #1C485F",
              borderRadius: "4px",
              padding: "6px 20px",
              outline: "none",
            }}
          >
            Source code
          </button>
          <button
            onClick={() => setOpenUnsubscribeModal(true)}
            style={{
              border: "1px solid #1C485F",
              borderRadius: "4px",
              padding: "6px 16px",
              outline: "none",
            }}
          >
            Unsubscribe link
          </button>
        </div>
        <p>below will have to display editor</p>
        <p
          style={{
            color: "#868686",
            fontFamily: "Source Sans 3",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          {" "}
          A great email signature can improve email engagement.
        </p>
      </div>
    );
  };

  const [healthData, setHealthData] = useState([
    {
      id: 1,
      title: "SPF",
      status: "Inactive",
      bgHex: "#FDF2E1",
      textHex: "#D4AB3D",
      text: "issue found",
      value: [],
    },
    // {
    //   id: 2,
    //   title: "DKIM",
    //   status: "Inactive",
    //   bgHex: "#FDF2E1",
    //   textHex: "#D4AB3D",
    //   text: "issue found",
    // },
    // {
    //   id: 3,
    //   title: "DMARC",
    //   status: "Missing",
    //   bgHex: "#FFEDE8",
    //   textHex: "#FD3735",
    //   text: "Missing",
    // },
    {
      id: 4,
      title: "MX",
      status: "Active",
      bgHex: "#E9F7E9",
      textHex: "#009C35",
      text: "Valid",
      value: [],
    },
    {
      id: 5,
      title: "A-record",
      status: "",
      bgHex: "",
      textHex: "",
      text: "",
      value: [],
    },
    // {
    //   id: 6,
    //   title: "rDNS",
    //   status: "Active",
    //   bgHex: "#E9F7E9",
    //   textHex: "#009C35",
    //   text: "Valid",
    // },
  ]);
  const domainHealth = () => {
    return (
      <div style={{ padding: "12px" }}>
        <ul
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: "20px",
          }}
        >
          {console.log("jabbbbaaa", type)}
          {healthData.map((data) => (
            <li
              onClick={() => {
                setOpen5(true);
                setDetailsDomain(data.value);
                setRecordName(data.title);
              }}
              key={data.id}
              style={{
                backgroundColor: "#FAFAFA",
                borderRadius: "6px",
                padding: "20px 14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                opacity: type === "new" && "0.4",
                pointerEvents: type === "new" && "none",
              }}
            >
              <div
                style={{ display: "flex", gap: "12px", alignItems: "center" }}
              >
                <p
                  style={{
                    color: "#000",
                    fontFamily: "Source Sans 3",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                  }}
                >
                  {data.title}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 16V11"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.0055 8H11.9965"
                    stroke="#292D32"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  backgroundColor: data.bgHex,
                  borderRadius: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "4px 12px",
                }}
              >
                <p
                  style={{
                    color: data.textHex,
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.text}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <button
          onClick={() => {
            getAllDomainHealthData(email);
          }}
          style={{
            backgroundColor: "#1C485F",
            color: "#fff",
            fontFamily: "Source Sans 3",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            borderRadius: "4px",
            padding: "6px 12px",
            border: "1px solid #1C485F",
            outline: "none",
            margin: "8px 0px",
            opacity: type === "new" && "0.4",
            pointerEvents: type === "new" && "none",
          }}
        >
          Check health
        </button>
        {/* <div
          style={{
            display: "flex",
            gap: "6px",
            alignItems: "center",
            margin: "0px 0px 6px 0px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M18.3333 10.0001C18.3333 14.6001 14.6 18.3334 9.99996 18.3334C5.39996 18.3334 1.66663 14.6001 1.66663 10.0001C1.66663 5.40008 5.39996 1.66675 9.99996 1.66675C14.6 1.66675 18.3333 5.40008 18.3333 10.0001Z"
              stroke="#868686"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8416 9.69165 10.2 9.69165 9.67497V6.2583"
              stroke="#868686"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p
            style={{
              color: "#868686",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Last checked: 04 Nov 2023, 07:07 PM
          </p>
        </div> */}
      </div>
    );
  };

  const points = [
    {
      id: 1,
      point: "Prepare new mailboxes for outreach",
    },
    {
      id: 2,
      point: "Restore sender and domain reputation",
    },
    {
      id: 3,
      point: "Improve deliverability and inbox placement",
    },
    {
      id: 4,
      point: "Easy set-up, real results",
    },
  ];

  const emailWarmupUi = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "20px",
          padding: "12px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <ul>
            <p
              style={{
                color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                marginBottom: "4px",
              }}
            >
              Never land in Spam or Promotions
            </p>
            {points.map((data) => (
              <li
                key={data.id}
                style={{
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    height: "4px",
                    width: "4px",
                    backgroundColor: "#868686",
                    borderRadius: "100%",
                  }}
                ></div>
                {data.point}
              </li>
            ))}
          </ul>
          <button
            onClick={() => {
              history.push("/MailWarmUp");
            }}
            style={{
              backgroundColor: "#1C485F",
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "4px",
              outline: "none",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              alignSelf: "flex-start",
            }}
          >
            Start Warm-up
          </button>
        </div>
        <div
          style={{
            border: "1px solid #DDD",
            borderRadius: "6px",
            padding: "12px",
            flexGrow: 1,
          }}
        >
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
      </div>
    );
  };

  const bccToCrm = () => {
    return (
      <div
        style={{ padding: "12px", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            CRM email address
          </p>
          <p
            style={{
              color: "#1C485F",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              marginTop: "0px",
            }}
          >
            Where to find your CRM email
          </p>
        </div>
        <input
          placeholder="Enter your email address"
          type="email"
          style={{
            backgroundColor: "#FAFAFA",
            borderRadius: "6px",
            border: "1px solid #1C485F",
            padding: "8px 6px",
            flexGrow: 1,
            marginTop: "6px",
          }}
        />
      </div>
    );
  };
  function getAllDomainHealthData(Email) {
    let emailData = {
      email: Email,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/check-domain-health/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        console.log("eeejejejeekjekj", res.data);
        if (res.data.status) {
          res.data.details.map((val, idx) => {
            if (val.type === "A") {
              if (val.status) {
                healthData[2].status = "Active";
                healthData[2].bgHex = "#E9F7E9";
                healthData[2].textHex = "#009C35";
                healthData[2].text = "Valid";
                healthData[2].value = val.details;
              } else {
                healthData[2].status = "Missing";
                healthData[2].bgHex = "#FFEDE8";
                healthData[2].textHex = "#FD3735";
                healthData[2].text = "Missing";
              }
            }
            if (val.type === "MX") {
              if (val.status) {
                healthData[1].status = "Active";
                healthData[1].bgHex = "#E9F7E9";
                healthData[1].textHex = "#009C35";
                healthData[1].text = "Valid";
                healthData[1].value = val.details;
              } else {
                healthData[1].status = "Missing";
                healthData[1].bgHex = "#FFEDE8";
                healthData[1].textHex = "#FD3735";
                healthData[1].text = "Missing";
              }
            }
            if (val.type === "TXT") {
              if (val.status) {
                healthData[0].status = "Active";
                healthData[0].bgHex = "#E9F7E9";
                healthData[0].textHex = "#009C35";
                healthData[0].text = "Valid";
                healthData[0].value = val.details;
              } else {
                healthData[0].status = "Missing";
                healthData[0].bgHex = "#FFEDE8";
                healthData[0].textHex = "#FD3735";
                healthData[0].text = "Missing";
              }
            }
            setHealthData([...healthData]);
          });
        }
      })
      .catch((err) => console.log("Error"));
  }
  const renderOptionalSettings = () => {
    if (selected === "Signature") {
      return signatureUi();
    } else if (selected === "Custom tracking domain") {
      return customTrackingDomain();
    } else if (selected === "Domain health") {
      return domainHealth();
    } else if (selected === "Email warm-up") {
      return emailWarmupUi();
    } else {
      return bccToCrm();
    }
  };
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuOpen2, setMenuOpen2] = useState(false);
  const [menuOpen3, setMenuOpen3] = useState(false);
  const [menuOpen4, setMenuOpen4] = useState(false);
  const [catchSearchValue, setCatchSearchValue] = useState("");

  const handleMenuOpen = () => {
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };
  const emailSettings = () => {
    return (
      <div
        style={{
          border: "1px solid #DDD",
          backgroundColor: "#FFF",
          borderRadius: "4px",
          margin: "8px",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #DDD",
            padding: "12px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <svg
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowMailSettings(true);
              setAdvance(false);
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.57 5.92969L3.5 11.9997L9.57 18.0697"
              stroke="#1C485F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.5019 12H3.67188"
              stroke="#1C485F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
            }}
          >
            Email accounts
          </p>
        </div>
        <div style={{ padding: "12px" }}>
          <div
            style={{
              backgroundColor: "#D1DFE9",
              padding: "14px 12px",
              borderRadius: "12px",
              boxShadow: "2px 2px 4px 0 hsla(0,0%,55%,.15)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "#4B4B4B",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                padding: "0px 0px 6px 0px",
              }}
            >
              Email account settings
            </p>
            {type === "new" && (
              <div className="smtpemailtext">SMTP (Sending emails)</div>
            )}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3,1fr)",
                gap: "10px",
              }}
            >
              <div className="nameboxverifivtaion" style={{ width: "100%" }}>
                {type === "new" ? "From name" : "Name"}
                <input
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder="Enter name"
                  style={{
                    outline: "none",
                    borderRadius: "4px",
                    background: "var(--background-color, #FAFAFA)",
                    width: "100%",
                    border: "1px solid #1C485F",
                    padding: "13.5px 16px",
                  }}
                />
              </div>
              <div className="nameboxverifivtaion">
                {type === "new" ? "From email id" : "Email id"}
                <input
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  autoComplete="email"
                  placeholder="Enter your email address"
                  style={{
                    outline: "none",
                    borderRadius: "4px",
                    background: "var(--background-color, #FAFAFA)",
                    width: "100%",
                    border: "1px solid #1C485F",
                    padding: "13.5px 16px",
                  }}
                />
              </div>
              <div className="nameboxverifivtaion">
                App Password
                <TextField
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  onClick={() => {
                    setPasswordStatus({
                      clicked: true,
                      error: false,
                    });
                  }}
                  autoComplete="off"
                  sx={{ width: "100%" }}
                  value={password.replace(/ /g, "")}
                  type={showPassword ? "text" : "password"}
                  variant="standard"
                  placeholder="Enter your password"
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: !showPassword ? (
                      <img
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          togglePassword();
                        }}
                        src={eyeSlash}
                        alt=""
                      />
                    ) : (
                      <img
                        onClick={() => {
                          togglePassword();
                        }}
                        src={eye}
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                    ),

                    sx: {
                      padding: "10px 16px",
                      gap: "10px",
                      fontSize: "15px",
                      alignItems: "center",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      border: "1px solid #1C485F",
                      fontWeight: 400,
                      height: "48px",
                      // border: passwordStatus.clicked
                      //   ? "1px solid var(--color-secondary, #3471B8)"
                      //   : passwordStatus.error &&
                      //     "1px solid var(--color-error, #FF3434)",
                      background: "var(--background-color, #FAFAFA)",
                      "& input": {
                        color: "var(--color-dark-500, #868686)",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "20px",
                      },
                    },
                  }}
                />
                <div
                  onClick={() => {
                    howToCreate();
                  }}
                  className="howtocreate"
                >
                  How to create
                </div>
              </div>
            </div>
            <div
              className="advancedsettng"
              style={{
                borderBottom: "1px solid #DDD",
                marginTop: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                setAdvance(!advance);
              }}
            >
              Advanced setting{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M16.6004 7.45825L11.1671 12.8916C10.5254 13.5333 9.47539 13.5333 8.83372 12.8916L3.40039 7.45825"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            {advance && (
              <div className="advancesettbox">
                <div className="advancesubbox">
                  <div className="hostboxadvance">
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      <div className="hostcpompltebox">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "0px",
                          }}
                        >
                          {" "}
                          <div>Host *</div>{" "}
                          {/* <div className="createstlecolor">create</div> */}
                        </div>
                        {hostNameArr.length === 0 ? (
                          <TextField
                            value={hostName}
                            onChange={(e) => {
                              setHostName(e.target.value);
                            }}
                            variant="standard"
                            placeholder="Enter SMTP Host"
                            InputProps={{
                              disableUnderline: true,

                              sx: {
                                display: "flex",
                                height: "41px",
                                padding: "10px 16px",
                                alignItems: "flex-start",
                                gap: "10px",
                                borderRadius: "4px",
                                background: "var(--background-color, #FAFAFA)",
                                width: "21vw",
                                border: "1px solid #1C485F",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignSelf: "stretch",
                                "& input": {
                                  color: "var(--color-dark-900, #393939)",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                },
                              },
                            }}
                          />
                        ) : (
                          <FormControl size="medium" sx={{ width: "100%" }}>
                            <Select
                              onOpen={handleMenuOpen}
                              onClose={(event) => {
                                if (event.target.tagName === "INPUT") {
                                  event.preventDefault();
                                } else {
                                  setMenuOpen(false);
                                }
                              }}
                              open={menuOpen}
                              displayEmpty
                              variant="standard"
                              value={hostName}
                              disableUnderline
                              sx={{
                                outline: "none",
                                backgroundColor: "#FAFAFA",
                                padding: "6px 0px 6px 6px",
                                borderRadius: "4px",
                                fontStyle: "normal",
                                fontSize: "13px",
                                fontFamily: "Source Sans 3",
                                border: "1px solid #1C485F",
                                zIndex: 1,
                              }}
                              renderValue={(selected) => {
                                if (selected !== undefined) {
                                  if (selected.length === 0) {
                                    return <p>Select hostName</p>;
                                  }
                                }

                                return selected;
                              }}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                onClick={() => {
                                  setMenuOpen(true);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  borderBottom: "1px solid #DDD",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                              >
                                <input
                                  type="text"
                                  value={hostNameDup}
                                  onChange={(e) => {
                                    setHostNameDup(e.target.value);
                                  }}
                                  style={{
                                    flexGrow: 1,
                                    padding: "8px",
                                    outline: "none",
                                    backgroundColor: "#FAFAFA",
                                    borderRadius: "4px",
                                    border: "1px solid #DDD",
                                    userSelect: "none",
                                  }}
                                  placeholder="Select or create"
                                />
                                <button
                                  style={{
                                    backgroundColor: "#FAFAFA",
                                    borderRadius: "4px",
                                    padding: "8px 18px",
                                    color: "#000",
                                    outline: "none",
                                    border: "1px solid #DDD",
                                  }}
                                  onClick={() => {
                                    setHostName(hostNameDup);
                                    setHostNameDup("");
                                  }}
                                >
                                  Create
                                </button>
                              </MenuItem>
                              {hostNameArr.map((val, index) => (
                                <MenuItem
                                  onClick={(e) => {
                                    setHostName(val);
                                    setMenuOpen(false);
                                  }}
                                  disableRipple
                                  disableTouchRipple
                                  key={index}
                                  value={val}
                                  sx={{
                                    borderBottom:
                                      hostNameArr.length !== index + 1 &&
                                      "1px solid #DDD",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    color: "#838383",
                                  }}
                                >
                                  {val}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </div>
                      <div className="hostcpompltebox">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "0px",
                          }}
                        >
                          {" "}
                          <div>Port</div>{" "}
                          {/* <div className="createstlecolor">create</div> */}
                        </div>

                        <FormControl size="medium" sx={{ width: "100%" }}>
                          <Select
                            onOpen={() => {
                              setMenuOpen2(true);
                            }}
                            onClose={(event) => {
                              if (event.target.tagName === "INPUT") {
                                event.preventDefault();
                              } else {
                                setMenuOpen2(false);
                              }
                            }}
                            open={menuOpen2}
                            displayEmpty
                            variant="standard"
                            value={portNumber}
                            disableUnderline
                            sx={{
                              outline: "none",
                              backgroundColor: "#FAFAFA",
                              padding: "6px 0px 6px 6px",
                              borderRadius: "4px",
                              fontStyle: "normal",
                              fontSize: "13px",
                              fontFamily: "Source Sans 3",
                              border: "1px solid #1C485F",
                            }}
                            renderValue={(selected) => {
                              if (selected !== undefined) {
                                if (selected.length === 0) {
                                  return <p>Select portNumber</p>;
                                }
                              }

                              return selected;
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem
                              disableRipple
                              disableTouchRipple
                              onClick={() => {
                                setMenuOpen2(true);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                borderBottom: "1px solid #DDD",
                                "&:hover": {
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              <input
                                type="text"
                                value={portNumberDup}
                                onChange={(e) => {
                                  setPortNumberDup(e.target.value);
                                }}
                                style={{
                                  flexGrow: 1,
                                  padding: "8px",
                                  outline: "none",
                                  backgroundColor: "#FAFAFA",
                                  borderRadius: "4px",
                                  border: "1px solid #DDD",
                                  userSelect: "none",
                                }}
                                placeholder="Select or create"
                              />
                              <button
                                style={{
                                  backgroundColor: "#FAFAFA",
                                  borderRadius: "4px",
                                  padding: "8px 18px",
                                  color: "#000",
                                  outline: "none",
                                  border: "1px solid #DDD",
                                }}
                                onClick={() => {
                                  setPortNumber(portNumberDup);
                                  setPortNumberDup("");
                                }}
                              >
                                Create
                              </button>
                            </MenuItem>
                            {portNumberArr.map((val, index) => (
                              <MenuItem
                                onClick={(e) => {
                                  setPortNumber(val);
                                  setMenuOpen2(false);
                                }}
                                disableRipple
                                disableTouchRipple
                                key={index}
                                value={val}
                                sx={{
                                  borderBottom:
                                    portNumberArr.length !== index + 1 &&
                                    "1px solid #DDD",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "13px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  color: "#838383",
                                }}
                              >
                                {val}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="checkboxadvance">
                      {certArr.map((val) => {
                        return (
                          <FormControlLabel
                            value={val}
                            control={<Radio style={{ color: "#1C485F" }} />}
                            label={val}
                            onClick={(e) => {
                              setCert(e.target.value);
                            }}
                            checked={cert === val}
                          />
                        );
                      })}
                    </div>
                    <FormControlLabel
                      value="diff-reply"
                      control={<Checkbox style={{ color: "#1C485F" }} />}
                      label="Set a different reply-to address"
                      onClick={(e) => {
                        setDiffReply(!diffReply);
                      }}
                    />
                    {diffReply && (
                      <div className="replytoaddressbox">
                        Reply-to email address *
                        <TextField
                          autoComplete="off"
                          value={diffReplyMail}
                          onChange={(e) => {
                            setDiffReplyMail(e.target.value);
                          }}
                          variant="standard"
                          placeholder="john@doe.com"
                          InputProps={{
                            disableUnderline: true,

                            sx: {
                              display: "flex",
                              height: "48px",
                              padding: "10px 16px",
                              alignItems: "flex-start",
                              gap: "10px",
                              borderRadius: "4px",
                              border: "1px solid #1C485F",
                              background: "var(--background-color, #FAFAFA)",
                              width: type === "new" ? "21.5vw" : "33vw",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignSelf: "stretch",
                              "& input": {
                                color: "var(--color-dark-900, #393939)",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px",
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="rcvingmailbox">
                    <div className="rcvingheading">IMAP (Receiving emails)</div>
                    <FormControlLabel
                      value="rcv-confirm"
                      control={
                        <Checkbox
                          value={rcvConfirm}
                          onClick={(e) => {
                            setRcvConfirm(!rcvConfirm);
                          }}
                          style={{ color: "#1C485F" }}
                        />
                      }
                      label="I receive replies to an email account that's not my From  email"
                      onClick={(e) => {
                        setRcvConfirm(!rcvConfirm);
                      }}
                    />
                    {rcvConfirm && (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2,1fr)",
                          gap: "16px",
                        }}
                      >
                        <div className="nameboxverifivtaion">
                          Username *
                          <TextField
                            autoComplete="off"
                            value={replyName}
                            onChange={(e) => {
                              setReplyName(e.target.value);
                            }}
                            variant="standard"
                            placeholder="Enter user name"
                            InputProps={{
                              disableUnderline: true,

                              sx: {
                                display: "flex",
                                height: "48px",
                                padding: "10px 16px",
                                alignItems: "flex-start",
                                gap: "10px",
                                borderRadius: "4px",
                                border: "1px solid #1C485F",
                                background: "var(--background-color, #FAFAFA)",
                                width: "100%",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignSelf: "stretch",
                                "& input": {
                                  color: "var(--color-dark-900, #393939)",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className="nameboxverifivtaion">
                          App Password
                          <TextField
                            autoComplete="off"
                            onChange={(e) => {
                              setReplyPassword(e.target.value);
                            }}
                            onClick={() => {
                              setReplyPasswordStatus({
                                clicked: true,
                                error: false,
                              });
                            }}
                            value={replyPassword.replace(/ /g, "")}
                            type={showReplyPassword ? "text" : "password"}
                            variant="standard"
                            placeholder="Enter your password"
                            InputProps={{
                              disableUnderline: true,
                              endAdornment: !showReplyPassword ? (
                                <img
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setShowReplyPassword(!showReplyPassword);
                                  }}
                                  src={eyeSlash}
                                  alt=""
                                />
                              ) : (
                                <img
                                  onClick={() => {
                                    setShowReplyPassword(!showReplyPassword);
                                  }}
                                  src={eye}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                />
                              ),

                              sx: {
                                padding: "10px 16px",
                                gap: "10px",
                                fontSize: "15px",
                                border: "1px solid #1C485F",
                                width: "100%",
                                alignItems: "center",
                                alignSelf: "stretch",
                                borderRadius: "4px",
                                fontWeight: 400,
                                height: "48px",
                                // border: passwordStatus.clicked
                                //   ? "1px solid var(--color-secondary, #3471B8)"
                                //   : passwordStatus.error &&
                                //     "1px solid var(--color-error, #FF3434)",
                                background: "var(--background-color, #FAFAFA)",
                                "& input": {
                                  color: "var(--color-dark-500, #868686)",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                },
                              },
                            }}
                          />
                          <div className="howtocreate">How to create</div>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      <div className="hostcpompltebox">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "0px",
                          }}
                        >
                          {" "}
                          <div>Host *</div>{" "}
                          {/* <div className="createstlecolor">create</div> */}
                        </div>
                        {rcvHostArr.length === 0 ? (
                          <TextField
                            autoComplete="off"
                            value={rcvHostName}
                            onChange={(e) => {
                              setRcvHostName(e.target.value);
                            }}
                            variant="standard"
                            placeholder="Enter IMAP Host"
                            InputProps={{
                              disableUnderline: true,

                              sx: {
                                display: "flex",
                                height: "41px",
                                padding: "10px 16px",
                                alignItems: "flex-start",
                                gap: "10px",
                                borderRadius: "4px",
                                border: "1px solid #1C485F",
                                background: "var(--background-color, #FAFAFA)",
                                width: "100%",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignSelf: "stretch",
                                "& input": {
                                  color: "var(--color-dark-900, #393939)",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                },
                              },
                            }}
                          />
                        ) : (
                          <FormControl size="medium" sx={{ width: "100%" }}>
                            <Select
                              onOpen={() => {
                                setMenuOpen3(true);
                              }}
                              onClose={(event) => {
                                if (event.target.tagName === "INPUT") {
                                  event.preventDefault();
                                } else {
                                  setMenuOpen3(false);
                                }
                              }}
                              open={menuOpen3}
                              displayEmpty
                              variant="standard"
                              value={rcvHostName}
                              disableUnderline
                              sx={{
                                outline: "none",
                                backgroundColor: "#FAFAFA",
                                padding: "6px 0px 6px 6px",
                                borderRadius: "4px",
                                fontStyle: "normal",
                                fontSize: "13px",
                                fontFamily: "Source Sans 3",
                                border: "1px solid #1C485F",
                              }}
                              renderValue={(selected) => {
                                if (selected !== undefined) {
                                  if (selected.length === 0) {
                                    return <p>Select rcvHost</p>;
                                  }
                                }

                                return selected;
                              }}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                onClick={() => {
                                  setMenuOpen3(true);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  borderBottom: "1px solid #DDD",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                              >
                                <input
                                  type="text"
                                  value={rcvHostNameDup}
                                  onChange={(e) => {
                                    setRcvHostNameDup(e.target.value);
                                  }}
                                  style={{
                                    flexGrow: 1,
                                    padding: "8px",
                                    outline: "none",
                                    backgroundColor: "#FAFAFA",
                                    borderRadius: "4px",
                                    userSelect: "none",
                                    border: "1px solid #DDD",
                                  }}
                                  placeholder="Select or create"
                                />
                                <button
                                  style={{
                                    backgroundColor: "#FAFAFA",
                                    borderRadius: "4px",
                                    padding: "8px 18px",
                                    color: "#000",
                                    outline: "none",
                                    border: "1px solid #DDD",
                                  }}
                                  onClick={() => {
                                    setRcvHostName(rcvHostNameDup);
                                    setRcvHostNameDup("");
                                  }}
                                >
                                  Create
                                </button>
                              </MenuItem>
                              {rcvHostArr.map((val, index) => (
                                <MenuItem
                                  onClick={(e) => {
                                    setRcvHostName(val);
                                    setMenuOpen3(false);
                                  }}
                                  disableRipple
                                  disableTouchRipple
                                  key={index}
                                  value={val}
                                  sx={{
                                    borderBottom:
                                      rcvHostArr.length !== index + 1 &&
                                      "1px solid #DDD",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    fontStyle: "normal",
                                    color: "#838383",
                                  }}
                                >
                                  {val}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </div>
                      <div className="hostcpompltebox">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "0px",
                          }}
                        >
                          {" "}
                          <div>Port</div>{" "}
                          {/* <div className="createstlecolor">create</div> */}
                        </div>

                        <FormControl size="medium" sx={{ width: "100%" }}>
                          <Select
                            onOpen={() => {
                              setMenuOpen4(true);
                            }}
                            onClose={(event) => {
                              if (event.target.tagName === "INPUT") {
                                event.preventDefault();
                              } else {
                                setMenuOpen4(false);
                              }
                            }}
                            open={menuOpen4}
                            displayEmpty
                            variant="standard"
                            value={rcvPortNumber}
                            disableUnderline
                            sx={{
                              outline: "none",
                              backgroundColor: "#FAFAFA",
                              padding: "6px 0px 6px 6px",
                              borderRadius: "4px",
                              fontStyle: "normal",
                              fontSize: "13px",
                              fontFamily: "Source Sans 3",
                              border: "1px solid #1C485F",
                            }}
                            renderValue={(selected) => {
                              if (selected !== undefined) {
                                if (selected.length === 0) {
                                  return <p>Select RcvPortNumber</p>;
                                }
                              }

                              return selected;
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem
                              disableRipple
                              disableTouchRipple
                              onClick={() => {
                                setMenuOpen4(true);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                borderBottom: "1px solid #DDD",
                                "&:hover": {
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              <input
                                type="text"
                                value={rcvPortNumberDup}
                                onChange={(e) => {
                                  setRcvPortNumberDup(e.target.value);
                                }}
                                style={{
                                  flexGrow: 1,
                                  padding: "8px",
                                  outline: "none",
                                  backgroundColor: "#FAFAFA",
                                  borderRadius: "4px",
                                  userSelect: "none",
                                  border: "1px solid #DDD",
                                }}
                                placeholder="Select or create"
                              />
                              <button
                                style={{
                                  backgroundColor: "#FAFAFA",
                                  borderRadius: "4px",
                                  padding: "8px 18px",
                                  color: "#000",
                                  outline: "none",
                                  border: "1px solid #DDD",
                                }}
                                onClick={() => {
                                  setRcvPortNumber(rcvPortNumberDup);
                                  setRcvPortNumberDup("");
                                }}
                              >
                                Create
                              </button>
                            </MenuItem>
                            {rcvPortNumberArr.map((val, index) => (
                              <MenuItem
                                onClick={(e) => {
                                  setRcvPortNumber(val);
                                  setMenuOpen4(false);
                                }}
                                disableRipple
                                disableTouchRipple
                                key={index}
                                value={val}
                                sx={{
                                  borderBottom:
                                    rcvPortNumberArr.length !== index + 1 &&
                                    "1px solid #DDD",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "13px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  color: "#838383",
                                }}
                              >
                                {val}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              onClick={() => {
                addSender();
              }}
              className="confirmshcedulepink"
              style={{
                // opacity:
                //   (name === "" ||
                //     email === "" ||
                //     password === "" ||
                //     hostName === "" ||
                //     portNumber === "") &&
                //   "0.3",
                pointerEvents:
                  (name === "" ||
                    email === "" ||
                    password === "" ||
                    hostName === "" ||
                    portNumber === "") &&
                  "none",
                marginTop: "14px",
                alignSelf: "flex-start",
                padding: "12px 18px",
              }}
            >
              {sendLoader ? (
                <CircularProgress
                  size={30}
                  style={{
                    color: "#FFF",
                  }}
                />
              ) : (
                "Check Connection"
              )}
            </div>
          </div>
          {healthData[0].value.length !== 0 && (
            <>
              <div
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  padding: "14px 0px",
                }}
              >
                Optional settings
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FAFAFA",
                  padding: "0px 10px",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              >
                {arrayOfObjects.map((val) => {
                  return (
                    <div
                      onClick={() => {
                        setSelected(val.title);
                      }}
                      key={val.id}
                      style={{
                        color: "#000",
                        cursor: "pointer",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        borderBottom: `3px solid ${
                          selected === val.title ? "#1C485F" : "transparent"
                        }`,
                        padding: "10px 6px",
                      }}
                    >
                      {val.title}
                    </div>
                  );
                })}
              </div>
              <div style={{ border: "1px solid #DDD", borderRadius: "12px" }}>
                {renderOptionalSettings()}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  function checkStatusOfEmail(sender) {
    setStatusLoader(true);
    let senderData = {
      code: "",
      fromEmail: sender.FromEmail,
      fromName: sender.FromName,
      password: sender.Password,
      port: sender.Port,
      host: sender.Host,
      service: sender.Service,
      serviceName: sender.ServiceName,
      imapUsername: sender.ImapUsername,
      imapPassword: sender.ImapPassword,
      imapHost: sender.ImapHost,
      imapPort: sender.ImapPort,
      imapEmail: sender.ImapEmail,
      limit: sender.Limit,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/check-user-added-email-connection/${
          userDetails && userDetails.details._id
        }`,
        senderData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        setShowToast(true);
        if (res.data.status) {
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          console.log("erorr----------------------");
          setAdvance(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        }
        setStatusLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    const filteredRecords = senderMailsCopy?.filter((eachMail) => {
      return catchSearchValue.toLowerCase() === ""
        ? eachMail
        : eachMail.FromEmail.toLowerCase().includes(
            catchSearchValue.toLowerCase()
          );
    });
    if (filteredRecords.length > 0) {
      setSenderMails(filteredRecords);
    } else {
      setSenderMails([]);
    }
  }, [catchSearchValue]);

  function editFromEmail(val) {
    setAddStatus(true);
    setEmail(val.FromEmail);
    getAllDomainHealthData(val.FromEmail);
    setName(val.FromName);
    setPassword(val.Password);
    setHostName(val.Host);
    setRcvHostName(val.ImapHost);
    setPortNumber(val.Port);
    setRcvPortNumber(val.ImapPort);
    setReplyName(val.ImapUsername);
    setDiffReplyMail(val.ImapEmail);
    setReplyPassword(val.ImapPassword);
    setCert("SSL");
    if (val.ServiceName === "gmail") {
      setHostNameArr(hostNameGoogle);
      setRcvHostArr(rcvHostArrGmail);
    } else setType("edit");
    history.push("/Email/accounts/settings");
    setSelected("Domain health");
    switch (mailType) {
      case "gmail":
        setHostNameArr(hostNameGoogle);
        setRcvHostArr(rcvHostArrGmail);
        break;
      case "microsoft":
        setHostNameArr(hostNameMicrosoft);
        setRcvHostArr(rcvHostArrMicrosoft);
        break;
      case "zoho":
        setHostNameArr(hostNameZoho);
        setRcvHostArr(rcvHostArrZoho);
        break;
      case "godaddy":
        setHostNameArr(hostNameGoDaddy);
        setRcvHostArr(rcvHostArrGoDaddy);
        break;
      case "private":
        setHostNameArr(hostNamePrivate);
        setRcvHostArr(rcvHostArrPrivate);
        break;
      case "qq":
        setHostNameArr(hostNameQQ);
        setRcvHostArr(rcvHostArrQq);
        break;
      case "mailgun":
        setHostNameArr(hostNameMailGun);
        break;
      case "hostinger":
        setHostNameArr(hostNameHostinger);
        setRcvHostArr(rcvHostArrHostinger);
        break;
      case "titan":
        setHostNameArr(hostNameTitan);
        setRcvHostArr(rcvHostArrTitan);
        break;
      case "amazonwork":
        setHostNameArr(hostNameAmazonWork);
        setRcvHostArr(rcvHostArrAmazonWork);
        break;
      case "amazonses":
        setHostNameArr(hostNameAmazonSes);
        break;
      case "aliyun":
        setHostNameArr(hostNameAliyun);
        break;
      case "locaweb":
        setHostNameArr(hostNameLocaWeb);
        setRcvHostArr(rcvHostArrLocaWeb);
        break;
      case "ionos":
        setHostNameArr(hostNameIonos);
        setRcvHostArr(rcvHostArrIonos);
        break;
      case "sendgrid":
        setHostNameArr(hostNameSendGrid);
        break;
      case "other":
        break;
      default:
      // result = 'This is the default case';
    }
  }
  const [showMailSettings, setShowMailSettings] = useState(true);
  const [openWorkSpaceModal, setOpenWorkSpaceModal] = useState(false);
  const [openAppPasswordModal, setOpenAppPasswordModal] = useState(false);
  const [openSetUpPasswordModal, setOpenSetUpPasswordModal] = useState(false);
  const [openMicrosoftConnectionModal, setOpenMicrosoftConnectionModal] =
    useState(false);
  const [gmailType, setGmailType] = useState("");

  const handleCloseGenAppPasswordModal = (data) => {
    setOpenAppPasswordModal(false);
    console.log("value received", data);
    if (data && gmailType === "SMTP") {
      setOpenSetUpPasswordModal(true);
    } else {
      if (data && gmailType === "WorkSpace") {
        setOpenWorkSpaceModal(true);
      }
    }
  };

  const handleCloseModals = (data) => {
    console.log(data);
    if (data === "Ok") {
      setShowMailSettings(false);
      setOpen3(false);
      setOpenSetUpPasswordModal(false);
      setOpenAppPasswordModal(false);
    } else {
      // setOpen3(false);
      setOpenSetUpPasswordModal(false);
    }
  };

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.openInstructionModal}
        onClose={() => props.setterFunForEmailInstructionModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.openInstructionModal}>
          <Box sx={style}>
            <Typography
              sx={{
                padding: "4px 0px",
                fontSize: "22px",
                color: "#4B4B4B",
                fontWeight: "700",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                textAlign: "center",
                marginBottom: "6px",
              }}
            >
              Adding new email
            </Typography>
            <div className="space-y-4">
              <p
                style={{
                  color: "#4B4B4B",
                  fontWeight: "400",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                }}
              >
                1. If the email field for the new email being added, or any
                previously added email, is empty, the new email will be added
                successfully.
              </p>
              <p
                style={{
                  color: "#4B4B4B",
                  fontWeight: "400",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                }}
              >
                2. If the new email to be added and the previously added emails
                must share the same domain name, the new email will be
                successfully added only if it contains the domain name of the
                previously added emails.
              </p>
              <div>
                <span
                  style={{
                    color: "#4B4B4B",
                    fontWeight: "700",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    fontFamily: "Source Sans 3",
                  }}
                >
                  For example:
                </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <div style={{ padding: "6px" }}>
                    <span
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      Method:1
                    </span>
                    <ul
                      style={{
                        listStyle: "inside",
                        listStyleType: "roman",
                      }}
                    >
                      <li>get[name].com</li>
                      <li>try[name].com</li>
                      <li>use[name].com</li>
                      <li>hey[name].com</li>
                      <li>join[name].com</li>
                    </ul>
                  </div>
                  <div style={{ padding: "6px" }}>
                    <span
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      Method:2
                    </span>
                    <ul
                      style={{
                        listStyle: "inside",
                        listStyleType: "roman",
                      }}
                    >
                      <li>[name].com</li>
                      <li>[name].co.in</li>
                      <li>[name].io</li>
                      <li>[name].ac.in</li>
                      <li>
                        [name].net <b>etc...</b>
                      </li>
                    </ul>
                  </div>
                </div>
                <span>
                  <b>**Note:</b> Here the [name] is considered as domain name
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <button
                onClick={() => {
                  props.setterFunForEmailInstructionModal(false);
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  props.setterFunForEmailInstructionModal(false);
                  props.setOpenEmailAccountDrawer(true);
                  setType("new");
                  setEmail("");
                  setPassword("");
                  setName("");
                  setHostName("");
                  setHostNameArr([]);
                  setPortNumber("");
                  setCert("");
                  setRcvHostArr([]);
                  setRcvPortNumber("");
                  setRcvHostName("");
                  setHealthData([
                    {
                      id: 1,
                      title: "SPF",
                      status: "Inactive",
                      bgHex: "#FDF2E1",
                      textHex: "#D4AB3D",
                      text: "issue found",
                      value: [],
                    },

                    {
                      id: 4,
                      title: "MX",
                      status: "Active",
                      bgHex: "#E9F7E9",
                      textHex: "#009C35",
                      text: "Valid",
                      value: [],
                    },
                    {
                      id: 5,
                      title: "A-record",
                      status: "",
                      bgHex: "",
                      textHex: "",
                      text: "",
                      value: [],
                    },
                  ]);
                }}
                style={{
                  textTransform: "none",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 26px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
                className="bg-primary"
              >
                Continue
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const emailFunction = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        <div
          onClick={() => {
            setAddStatus(true);
            setSelected("Domain health");
            setHostName("smtp.gmail.com");
            setHostNameArr(hostNameGoogle);
            setPortNumber("465");
            setCert("SSL");
            setMailType("gmail");
            setRcvHostArr(rcvHostArrGmail);
            setRcvHostName(rcvHostArrGmail[0]);
            setRcvPortNumber("993");
            setMessagePerDay(200);
            setOpenAppPasswordModal(true);
            setGmailType("SMTP");
          }}
          className="newemailbox"
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
          }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="46"
              viewBox="0 0 45 46"
              fill="none"
            >
              <path
                d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
                fill="#EA4435"
              />
              <path
                d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
                fill="#00AC47"
              />
              <path
                d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
                fill="#FFBA00"
              />
              <path
                d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
                fill="#4285F4"
              />
              <path
                d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
                fill="#C52528"
              />
            </svg>
          </div>
          <div className="addacnttypename">Gmail(SMTP)</div>
        </div>
        <div
          onClick={() => {
            setOpenAppPasswordModal(true);
            setGmailType("WorkSpace");
          }}
          className="newemailbox"
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
          }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="46"
              viewBox="0 0 45 46"
              fill="none"
            >
              <path
                d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
                fill="#EA4435"
              />
              <path
                d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
                fill="#00AC47"
              />
              <path
                d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
                fill="#FFBA00"
              />
              <path
                d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
                fill="#4285F4"
              />
              <path
                d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
                fill="#C52528"
              />
            </svg>
          </div>
          <div className="addacnttypename">Workspace</div>
        </div>
        <div
          onClick={() => {
            setOpenMicrosoftConnectionModal(true);
          }}
          className="newemailbox"
          style={{
            boxShadow:
              "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
          }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="45"
              height="46"
              viewBox="0 0 48 48"
            >
              <path
                fill="#1a237e"
                d="M43.607,23.752l-7.162-4.172v11.594H44v-6.738C44,24.155,43.85,23.894,43.607,23.752z"
              ></path>
              <path
                fill="#0c4999"
                d="M33.919,8.84h9.046V7.732C42.965,6.775,42.19,6,41.234,6H17.667c-0.956,0-1.732,0.775-1.732,1.732 V8.84h9.005H33.919z"
              ></path>
              <path
                fill="#0f73d9"
                d="M33.919,33.522h7.314c0.956,0,1.732-0.775,1.732-1.732v-6.827h-9.046V33.522z"
              ></path>
              <path
                fill="#0f439d"
                d="M15.936,24.964v6.827c0,0.956,0.775,1.732,1.732,1.732h7.273v-8.558H15.936z"
              ></path>
              <path
                fill="#2ecdfd"
                d="M33.919 8.84H42.964999999999996V16.866999999999997H33.919z"
              ></path>
              <path
                fill="#1c5fb0"
                d="M15.936 8.84H24.941000000000003V16.866999999999997H15.936z"
              ></path>
              <path
                fill="#1467c7"
                d="M24.94 24.964H33.919V33.522H24.94z"
              ></path>
              <path
                fill="#1690d5"
                d="M24.94 8.84H33.919V16.866999999999997H24.94z"
              ></path>
              <path
                fill="#1bb4ff"
                d="M33.919 16.867H42.964999999999996V24.963H33.919z"
              ></path>
              <path
                fill="#074daf"
                d="M15.936 16.867H24.941000000000003V24.963H15.936z"
              ></path>
              <path
                fill="#2076d4"
                d="M24.94 16.867H33.919V24.963H24.94z"
              ></path>
              <path
                fill="#2ed0ff"
                d="M15.441,42c0.463,0,26.87,0,26.87,0C43.244,42,44,41.244,44,40.311V24.438 c0,0-0.03,0.658-1.751,1.617c-1.3,0.724-27.505,15.511-27.505,15.511S14.978,42,15.441,42z"
              ></path>
              <path
                fill="#139fe2"
                d="M42.279,41.997c-0.161,0-26.59,0.003-26.59,0.003C14.756,42,14,41.244,14,40.311V25.067 l29.363,16.562C43.118,41.825,42.807,41.997,42.279,41.997z"
              ></path>
              <path
                fill="#00488d"
                d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"
              ></path>
              <path
                fill="#fff"
                d="M13.914,18.734c-3.131,0-5.017,2.392-5.017,5.343c0,2.951,1.879,5.342,5.017,5.342 c3.139,0,5.017-2.392,5.017-5.342C18.931,21.126,17.045,18.734,13.914,18.734z M13.914,27.616c-1.776,0-2.838-1.584-2.838-3.539 s1.067-3.539,2.838-3.539c1.771,0,2.839,1.585,2.839,3.539S15.689,27.616,13.914,27.616z"
              ></path>
            </svg>
          </div>
          <div className="addacnttypename">Outlook</div>
        </div>
        <div
          style={{
            backgroundColor: "#FFF",
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            borderRadius: 6,
            padding: "14px 6px",
            boxShadow:
              "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 6,
              cursor: "pointer",
            }}
            onClick={() => {
              setAddStatus(true);
              setAdvance(true);
              setShowMailSettings(false);
              setSelected("Domain health");
              setHostNameArr([]);
              setRcvHostArr([]);
              setPortNumber("465");
              setCert("SSL");
              setMessagePerDay(200);
              setRcvPortNumber("993");
              setMailType("other");
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 20px",
                borderRight: "1px solid #DDD",
              }}
            >
              <MailOutlineIcon sx={{ fontSize: "40px" }} />
            </div>
            <div
              style={{
                padding: "2px 12px",
              }}
            >
              <p
                style={{
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                }}
              >
                Any Provider
              </p>
              <p
                style={{
                  color: "#000",
                  fontFamily: "Source Sans 3",
                  fontSize: "28px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "20px",
                }}
              >
                IMAP / SMTP
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  function howToCreate() {
    switch (mailType) {
      case "gmail":
        window.open(
          "https://coldsender.com/how-to-create-an-app-password-in-gmail/",
          "_blank"
        );
        break;
      case "microsoft":
        console.log("microsoft");
        break;
      case "zoho":
        window.open("https://coldsender.com/zoho-email/", "_blank");
        break;
      case "godaddy":
        break;
      case "private":
        break;
      case "qq":
        break;
      case "mailgun":
        window.open("https://coldsender.com/hostinger-email/", "_blank");
        break;
      case "hostinger":
        window.open(
          "https://coldsender.com/how-to-connect-mailgun-smtp-to-coldsender-com/",
          "_blank"
        );
        break;
      case "titan":
        break;
      case "amazonwork":
        break;
      case "amazonses":
        break;
      case "aliyun":
        break;
      case "locaweb":
        break;
      case "ionos":
        break;
      case "sendgrid":
        window.open("https://coldsender.com/sendgrid-api/", "_blank");
        break;
      case "other":
        break;
      default:
      // result = 'This is the default case';
    }
  }
  const divRef = useRef([]);
  const copyText = () => {
    // Ensure that the div reference is not null
    if (divRef.current) {
      // Create a range and select the text content of the div
      const range = document.createRange();
      range.selectNode(divRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // Execute the copy command
      document.execCommand("copy");

      // Clear the selection
      window.getSelection().removeAllRanges();

      // You can also provide user feedback here, like a message or notification
      console.log("Text copied to clipboard");
    }
  };
  return (
    <div
      style={{
        height: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        borderRadius: "5px",
        backgroundColor: "transparent",
      }}
    >
      <div>
        {/* mui modal is instruction modal */}
        {muiModal()}

        {/* workspace modal is it will mount when u click the workspace mail */}
        <WorkspaceModalUi
          openModal={openWorkSpaceModal}
          modalSetterFun={setOpenWorkSpaceModal}
          addEmailSetterFun={setOpen3}
        />

        {openAppPasswordModal && (
          <GenerateAppPasswordModal
            openAppPasswordModal={openAppPasswordModal}
            setOpenAppPasswordModal={handleCloseGenAppPasswordModal}
          />
        )}
        {openSetUpPasswordModal && (
          <SetUpAppPasswordModalUi
            openSetUpPasswordModal={openSetUpPasswordModal}
            setOpenSetUpPasswordModal={handleCloseModals}
          />
        )}
        {openMicrosoftConnectionModal && (
          <MicrosoftAccountModal
            openSetUpPasswordModal={openMicrosoftConnectionModal}
            setOpenMicrosoftConnectionModal={setOpenMicrosoftConnectionModal}
          />
        )}

        <Drawer
          placement={"right"}
          open={props.openEmailAccountDrawer}
          onClose={() => {
            props.setOpenEmailAccountDrawer(false);
          }}
          size={showMailSettings ? "xs" : "sm"}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                padding: "18px 16px",
                borderBottom: "1px solid #DDD",
                flexShrink: 0,
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  color: "#4B4B4B",
                }}
              >
                Add New Email Account
              </p>
            </div>
            <div
              style={{
                flexGrow: 1,
                overflowY: "scroll",
                backgroundColor: "#FFF",
                padding: "12px 16px",
                display: "flex",
                flexDirection: "column",
                justifyContent: showMailSettings ? "center" : "flex-start",
                gap: "12px",
              }}
            >
              {showMailSettings ? emailFunction() : emailSettings()}
            </div>
          </div>
        </Drawer>
      </div>
      {open4 && (
        <Modal
          open={open4}
          onClose={() => {
            setOpen4(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div className="modaltext">Confirm Delete</div>
            <div className="modalsubtext">
              Are you sure you want to delete this Account?
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen4(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  deleteAccountUser();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        open={open5}
        onClose={() => {
          setOpen5(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopup" style={{ width: "38vw", left: "34%" }}>
          <div className="modaltext">{recordName}</div>
          <div className="modalsubtext">
            {recordName === "SPF"
              ? "SPF record prevents spammers from sending emails from your domain"
              : recordName === "MX"
              ? "MX record specifies which email server is responsible for handling emails for your domain. It is required for delivering emails."
              : "A record helps computers find the server hosting your domain. This is necessary for your email to be delivered."}
          </div>

          <div className="modalmoxtextlabel">
            Your domain’s {recordName} record:
          </div>
          <div className="boxofdomian">
            <div style={{ float: "right" }}>
              <ContentCopyIcon
                onClick={copyText}
                style={{ cursor: "pointer" }}
              />
            </div>
            {detailsDomain.map((val, idx) => {
              return (
                <div ref={divRef} className="modalmoxtextlabel">
                  {recordName === "MX"
                    ? `Priority:${val.priority} host:${val.exchange}`
                    : recordName === "SPF"
                    ? `Record:${val[0]}`
                    : `Ip:${val}`}
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default EmailAccountsCopy;
